import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
const routesP = [{
  path: '/',
  name: 'Index',
  component: () => import('@/views/pc/index.vue')
},{
  path: '/profile',
  name: 'profile',
  component: () => import('@/views/pc/profile.vue')
},{
  path: '/culture',
  name: 'culture',
  component: () => import('@/views/pc/culture.vue')
},{
  path: '/contact',
  name: 'contact',
  component: () => import('@/views/pc/contact.vue')
},{
  path: '/privacy',
  name: 'privacy',
  component: () => import('@/views/pc/privacy.vue')
},{
  path: '/mergence',
  name: 'mergence',
  component: () => import('@/views/pc/mergence.vue')
},{
  path: '/media',
  name: 'media',
  component: () => import('@/views/pc/media.vue')
},{
  path: '/goods',
  name: 'goods',
  component: () => import('@/views/pc/goods.vue')
},{
  path: '/biomedical',
  name: 'biomedical',
  component: () => import('@/views/pc/biomedical.vue')
},{
  path: '/energy',
  name: 'energy',
  component: () => import('@/views/pc/energy.vue')
},{
  path: '/mineral',
  name: 'mineral',
  component: () => import('@/views/pc/mineral.vue')
},{
  path: '/tourism',
  name: 'tourism',
  component: () => import('@/views/pc/tourism.vue')
},{
  path: '/digital',
  name: 'digital',
  component: () => import('@/views/pc/digital.vue')
},{
  path: '/newinfrastructure',
  name: 'newinfrastructure',
  component: () => import('@/views/pc/newinfrastructure.vue')
},{
  path: '/automobilemaking',
  name: 'automobilemaking',
  component: () => import('@/views/pc/automobilemaking.vue')
},{
  path: '/invest',
  name: 'invest',
  component: () => import('@/views/pc/invest.vue')
},{
  path: '/newscenter',
  name: 'newscenter',
  component: () => import('@/views/pc/newscenter.vue')
},{
  path: '/newslist',
  name: 'newslist',
  component: () => import('@/views/pc/newslist.vue')
},{
  path: '/newsdetail',
  name: 'newsdetail',
  component: () => import('@/views/pc/newsdetail.vue')
},{
  path: '/talent',
  name: 'talent',
  component: () => import('@/views/pc/talent.vue')
},{
  path: '/training',
  name: 'training',
  component: () => import('@/views/pc/training.vue')
},{
  path: '/job',
  name: 'job',
  component: () => import('@/views/pc/job.vue')
},{
  path: '/resume',
  name: 'resume',
  component: () => import('@/views/pc/resume.vue')
},{
  path: '/product',
  name: 'product',
  component: () => import('@/views/pc/product.vue')
},{
  path: '/goodsList',
  name: 'goodsList',
  component: () => import('@/views/pc/goodsList.vue')
},{
  path: '/goodsDetail',
  name: 'goodsDetail',
  component: () => import('@/views/pc/goodsDetail.vue')
}]
const routesM = [{
  path: '/',
  name: 'mindex',
  component: () => import('@/views/mobile/index.vue')
},{
  path: '/profile',
  name: 'profile',
  component: () => import('@/views/mobile/profile.vue')
},{
  path: '/culture',
  name: 'culture',
  component: () => import('@/views/mobile/culture.vue')
},{
  path: '/mergence',
  name: 'mergence',
  component: () => import('@/views/mobile/mergence.vue')
},{
  path: '/contact',
  name: 'contact',
  component: () => import('@/views/mobile/contact.vue')
},{
  path: '/privacy',
  name: 'privacy',
  component: () => import('@/views/mobile/privacy.vue')
},{
  path: '/media',
  name: 'media',
  component: () => import('@/views/mobile/media.vue')
},{
  path: '/goods',
  name: 'goods',
  component: () => import('@/views/mobile/goods.vue')
},{
  path: '/biomedical',
  name: 'biomedical',
  component: () => import('@/views/mobile/biomedical.vue')
},{
  path: '/energy',
  name: 'energy',
  component: () => import('@/views/mobile/energy.vue')
},{
  path: '/mineral',
  name: 'mineral',
  component: () => import('@/views/mobile/mineral.vue')
},{
  path: '/tourism',
  name: 'tourism',
  component: () => import('@/views/mobile/tourism.vue')
},{
  path: '/digital',
  name: 'digital',
  component: () => import('@/views/mobile/digital.vue')
},{
  path: '/newinfrastructure',
  name: 'newinfrastructure',
  component: () => import('@/views/mobile/newinfrastructure.vue')
},{
  path: '/automobilemaking',
  name: 'automobilemaking',
  component: () => import('@/views/mobile/automobilemaking.vue')
},{
  path: '/invest',
  name: 'invest',
  component: () => import('@/views/mobile/invest.vue')
},{
  path: '/newslist',
  name: 'newslist',
  component: () => import('@/views/mobile/newslist.vue')
},{
  path: '/newsdetail',
  name: 'newsdetail',
  component: () => import('@/views/mobile/newsdetail.vue')
},{
  path: '/talent',
  name: 'talent',
  component: () => import('@/views/mobile/talent.vue')
},{
  path: '/training',
  name: 'training',
  component: () => import('@/views/mobile/training.vue')
},{
  path: '/job',
  name: 'job',
  component: () => import('@/views/mobile/job.vue')
},{
  path: '/resume',
  name: 'resume',
  component: () => import('@/views/mobile/resume.vue')
},{
  path: '/product',
  name: 'product',
  component: () => import('@/views/mobile/product.vue')
},{
  path: '/goodsList',
  name: 'goodsList',
  component: () => import('@/views/mobile/goodsList.vue')
},{
  path: '/goodsDetail',
  name: 'goodsDetail',
  component: () => import('@/views/mobile/goodsDetail.vue')
}]  
var routes = [];
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  routes = routesM
} else {
  routes = routesP
}
const router = new Router({
  mode: 'history',
  routes
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js